import { EtsyProduct } from '@/hooks/useEtsyProducts';
import { EtsyOrder } from '@/types/etsy';

export const DEMO_PRODUCTS: EtsyProduct[] = [
  {
    id: "1",
    listingId: 123456789,
    title: "Handmade Ceramic Mug",
    description: "A beautiful handmade ceramic mug for your morning coffee.",
    price: 24.99,
    originalPrice: 24.99,
    currencyCode: "USD",
    quantity: 50,
    salesCount: 25,
    refundCount: 2,
    cancelledCount: 1,
    state: "active",
    url: "https://www.etsy.com/listing/123456789",
    mainImageUrl: "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
    imageUrls: [
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000001_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000002_0000.jpg"
    ],
    shippingProfiles: [],
    createdAt: "2023-01-01T00:00:00.000Z",
    updatedAt: "2023-01-01T00:00:00.000Z",
    views: 500
  },
  {
    id: "2",
    listingId: 987654321,
    title: "Organic Cotton T-shirt",
    description: "A soft and comfortable t-shirt made from organic cotton.",
    price: 39.99,
    originalPrice: 39.99,
    currencyCode: "USD",
    quantity: 100,
    salesCount: 50,
    refundCount: 5,
    cancelledCount: 2,
    state: "active",
    url: "https://www.etsy.com/listing/987654321",
    mainImageUrl: "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
    imageUrls: [
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000001_0000.jpg"
    ],
    shippingProfiles: [],
    createdAt: "2023-02-15T00:00:00.000Z",
    updatedAt: "2023-02-15T00:00:00.000Z",
    views: 750
  },
  {
    id: "3",
    listingId: 1122334455,
    title: "Leather Messenger Bag",
    description: "A stylish and durable messenger bag made from high-quality leather.",
    price: 129.99,
    originalPrice: 129.99,
    currencyCode: "USD",
    quantity: 25,
    salesCount: 10,
    refundCount: 1,
    cancelledCount: 0,
    state: "active",
    url: "https://www.etsy.com/listing/1122334455",
    mainImageUrl: "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
    imageUrls: [
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000001_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000002_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000003_0000.jpg"
    ],
    shippingProfiles: [],
    createdAt: "2023-03-01T00:00:00.000Z",
    updatedAt: "2023-03-01T00:00:00.000Z",
    views: 1000
  },
  {
    id: "4",
    listingId: 6677889900,
    title: "Set of Watercolor Paints",
    description: "A vibrant set of watercolor paints for artists of all levels.",
    price: 49.99,
    originalPrice: 49.99,
    currencyCode: "USD",
    quantity: 75,
    salesCount: 30,
    refundCount: 3,
    cancelledCount: 1,
    state: "active",
    url: "https://www.etsy.com/listing/6677889900",
    mainImageUrl: "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
    imageUrls: [
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000001_0000.jpg"
    ],
    shippingProfiles: [],
    createdAt: "2023-03-15T00:00:00.000Z",
    updatedAt: "2023-03-15T00:00:00.000Z",
    views: 620
  },
  {
    id: "5",
    listingId: 5544332211,
    title: "Hand-poured Soy Candle",
    description: "A fragrant soy candle hand-poured with natural essential oils.",
    price: 19.99,
    originalPrice: 19.99,
    currencyCode: "USD",
    quantity: 120,
    salesCount: 60,
    refundCount: 6,
    cancelledCount: 3,
    state: "active",
    url: "https://www.etsy.com/listing/5544332211",
    mainImageUrl: "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
    imageUrls: [
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000000_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000001_0000.jpg",
      "https://i.etsystatic.com/0/0/00000000/000000000000/il_fullxfull.0000000002_0000.jpg"
    ],
    shippingProfiles: [],
    createdAt: "2023-04-01T00:00:00.000Z",
    updatedAt: "2023-04-01T00:00:00.000Z",
    views: 880
  }
];

export const DEMO_ORDERS: EtsyOrder[] = [
  {
    receiptId: "R1234567890",
    trackingId: "1Z999AA1234567890",
    customerName: "Sarah Johnson",
    productName: "Handmade Ceramic Mug Set",
    items: [
      { title: "Handmade Ceramic Mug Set" }
    ],
    city: "Los Angeles",
    zip: "90210",
    address: "123 Beverly Hills Blvd",
    country: "United States", // Add country
    date: "2024-03-15",
    status: "Shipped",
    totalAmount: 45.99,
    subtotalAmount: 39.99,
    currencyCode: "USD",
    customerEmail: "sarah.johnson@email.com",
    views: 1250
  },
  {
    receiptId: "R1234567891",
    trackingId: "1Z999AA1234567891",
    customerName: "Mike Chen",
    productName: "Vintage Leather Wallet",
    items: [
      { title: "Vintage Leather Wallet" }
    ],
    city: "New York",
    zip: "10001",
    address: "456 Manhattan Ave",
    country: "United States", // Add country
    date: "2024-03-14",
    status: "Processing",
    totalAmount: 89.50,
    subtotalAmount: 79.50,
    currencyCode: "USD",
    customerEmail: "mike.chen@email.com",
    views: 890
  },
  {
    receiptId: "R1234567892",
    trackingId: "1Z999AA1234567892",
    customerName: "Emma Wilson",
    productName: "Hand-knitted Wool Scarf",
    items: [
      { title: "Hand-knitted Wool Scarf" }
    ],
    city: "Chicago",
    zip: "60601",
    address: "789 Lake Shore Dr",
    country: "United States", // Add country
    date: "2024-03-13",
    status: "Delivered",
    totalAmount: 65.00,
    subtotalAmount: 58.00,
    currencyCode: "USD",
    customerEmail: "emma.wilson@email.com",
    views: 2100
  },
  {
    receiptId: "R1234567893",
    trackingId: "1Z999AA1234567893",
    customerName: "David Brown",
    productName: "Artisan Wooden Bowl",
    items: [
      { title: "Artisan Wooden Bowl" }
    ],
    city: "Seattle",
    zip: "98101",
    address: "321 Pine St",
    country: "United States", // Add country
    date: "2024-03-12",
    status: "New",
    totalAmount: 125.75,
    subtotalAmount: 110.00,
    currencyCode: "USD",
    customerEmail: "david.brown@email.com",
    views: 760
  },
  {
    receiptId: "R1234567894",
    trackingId: "1Z999AA1234567894",
    customerName: "Lisa Garcia",
    productName: "Silver Pendant Necklace",
    items: [
      { title: "Silver Pendant Necklace" }
    ],
    city: "Miami",
    zip: "33101",
    address: "654 Ocean Dr",
    country: "United States", // Add country
    date: "2024-03-11",
    status: "Shipped",
    totalAmount: 198.99,
    subtotalAmount: 179.99,
    currencyCode: "USD",
    customerEmail: "lisa.garcia@email.com",
    views: 1580
  }
];
